import React from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

export const OrganizationDropdown = ({
  data,
  className,
  onOrgSelected,
  selectedOrg,
  icon,
  clearEnabled = false,
  placeholder = "Select an organization...",
}) => {
  return (
    <Dropdown
      className={className}
      selected={selectedOrg}
      onOptionSelected={onOrgSelected}
    >
      <DropdownButton
        placeholder={placeholder}
        icon={icon ?? selectedOrg?.icon}
        clearEnabled={clearEnabled}
      >
        {selectedOrg?.name}
      </DropdownButton>
      <DropdownItems>
        {data?.map((organization) => (
          <DropdownItem key={organization.code} value={organization}>
            {organization.name}
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
